import api from '../../services/api'
import { CartEvent } from '../../pages/cart/types'
import { shopService } from '@/services/shop-service'
import { mediaService } from '@/services/media-service'

type CartContent = {
  id: string
  accountId: string
  event: CartEvent
}

export const getCart = async () => {
  return await shopService
    .readCart({})
    .then((r: any) => {
      if (r.data.success) {
        return Promise.resolve(
          r.data.payload.map((item: any) => {
            return item.event
          }),
        )
      } else {
        throw new Error(r.data.error)
      }
    })
    .catch((e: any) => {
      throw new Error(e.message)
    })
}

export const addToCart = async (eventId: string) => {
  return await shopService
    .addToCart({ eventId: eventId })
    .then((r: any) => {
      if (r.data.success) {
        return Promise.resolve(r.data.payload.event)
      } else {
        throw new Error(r.data.error)
      }
    })
    .catch((e: any) => {
      throw new Error(e.message)
    })
}

export const removeFromCart = async (eventId: string) => {
  return await shopService
    .removeFromCart({ eventId: eventId })
    .then((r: any) => {
      if (r.data.success) {
        return Promise.resolve(true)
      } else {
        throw new Error(r.data.error)
      }
    })
    .catch((e) => {
      throw new Error(e.message)
    })
}

export const clearCart = async () => {
  return await shopService
    .clearCart()
    .then((r: any) => {
      if (r.data.success) {
        return Promise.resolve(true)
      } else {
        throw new Error(r.data.error)
      }
    })
    .catch((e) => {
      throw new Error(e.message)
    })
}
